import styled from '@emotion/styled';
import { theme } from '../2022-component-library';
import { useBreakpoints } from '../helpers/useBreakpoints';

const StyledRadioButton = styled.div`
  display: flex;
  align-items: center;
  padding: 2px;
  input[type='radio'] {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    appearance: none;
    -webkit-appearance: none;
    height: ${({ lg }) => (lg ? '20px' : '15px')};
    width: ${({ lg }) => (lg ? '20px' : '15px')};
    background-color: transparent;
    border: 2px solid ${({ color }) => color};
    border-radius: 50%;
    cursor: pointer;
    outline: none;
    &:after {
      content: '';
      display: none;
      width: ${({ lg }) => (lg ? '10px' : '8px')};
      height: ${({ lg }) => (lg ? '10px' : '8px')};
      border-radius: 50%;
      background: ${({ color }) => color};
    }
    &:checked {
      &:after {
        display: block;
      }
    }
  }
  label {
    cursor: pointer;
    margin-left: ${({ lg }) => (lg ? '10px' : '3px')};
    color: #000;
  }
`;

const RadioButton = ({ label, id, name, value, onClick, checked }) => {
  const { lg } = useBreakpoints();
  return (
    <StyledRadioButton color={theme.colors.primary} lg={lg}>
      <input type='radio' id={id} name={name} value={value} onChange={onClick} checked={checked} />
      <label htmlFor={id}>{label}</label>
    </StyledRadioButton>
  );
};

export default RadioButton;
